document.addEventListener("DOMContentLoaded", function () {
    const voucherCheckbox = document.getElementById("voucher-checkbox");
    const voucherDetails = document.getElementById("voucher-details");
    const cartForm = document.getElementById("CartPageForm");

    if (voucherCheckbox) {
        voucherCheckbox.addEventListener("change", function () {
            if (voucherCheckbox.checked) {
                voucherDetails.style.display = "block";
            } else {
                voucherDetails.style.display = "none";
                clearVoucherErrors();
            }
        });
    }

    function clearVoucherErrors() {
        var errorMessages = document.querySelectorAll(".error-message");
        errorMessages.forEach(function (error) {
            error.style.display = "none";
        });
    }

    cartForm.addEventListener("submit", function (event) {
        clearVoucherErrors();
        let hasError = false;

        if (voucherCheckbox && voucherCheckbox.checked) {
            // お名前のチェック
            const voucherName = document.getElementById("voucher-name");
            if (voucherName.value.trim() === "") {
                document.getElementById("error-voucher-name").style.display =
                    "block";
                hasError = true;
            }

            // 郵便番号のチェック
            const voucherPostalCode = document.getElementById(
                "voucher-postal-code"
            );
            const postalCodePattern = /^\d{3}-\d{4}$/;
            if (!postalCodePattern.test(voucherPostalCode.value)) {
                document.getElementById(
                    "error-voucher-postal-code"
                ).style.display = "block";
                hasError = true;
            }

            // 都道府県のチェック
            const voucherPrefecture =
                document.getElementById("voucher-prefecture");
            if (voucherPrefecture.value.trim() === "") {
                document.getElementById(
                    "error-voucher-prefecture"
                ).style.display = "block";
                hasError = true;
            }

            // 市区町村のチェック
            const voucherCity = document.getElementById("voucher-city");
            if (voucherCity.value.trim() === "") {
                document.getElementById("error-voucher-city").style.display =
                    "block";
                hasError = true;
            }

            // 番地・建物名などのチェック
            const voucherAddressLine1 = document.getElementById(
                "voucher-address-line1"
            );
            if (voucherAddressLine1.value.trim() === "") {
                document.getElementById(
                    "error-voucher-address-line1"
                ).style.display = "block";
                hasError = true;
            }

            // 電話番号のチェック
            const voucherPhone = document.getElementById("voucher-phone");
            const phonePattern = /^\d{2,4}-\d{2,4}-\d{3,4}$/;
            if (!phonePattern.test(voucherPhone.value)) {
                document.getElementById("error-voucher-phone").style.display =
                    "block";
                hasError = true;
            }

            if (hasError) {
                event.preventDefault();
                alert("お食事券の送付先情報に誤りがあります。ご確認ください。");
                const checkoutButtons =
                    document.querySelectorAll(".cart__checkout");
                // ローディング状態をリセット
                checkoutButtons.forEach((btn) => {
                    if (btn.classList.contains("btn--loading")) {
                        btn.classList.remove("btn--loading");
                    }
                });
            }
        }
    });
});
